import Invite from './Invite';
import withLayout from 'hocs/withLayout';

/** Narrow column + horizontal gutter + outer top margin (24px / 48px). */
export default withLayout(Invite, {
  contentWidth: 'sm',
  margin: true,
});
